// @flow

import type { IncomingPayment } from '@tectonics/prs/incoming-payment';
import type { UserInputValues } from '@tectonics/prs/user-input-values';
import type { Receipt } from '@tectonics/prs/receipts';
import { getReceipts } from '@tectonics/prs/incoming-payment';
import { getAmountLocal } from '@tectonics/prs/receipts';
import { getCurrencyCode } from '@tectonics/prs/money/amount/get-currency-code';
import { getInstalmentsPlanFromApi } from './instalments-plan-service';
import { normalizeInstalmentsPlan } from './normalize-instalments-plan';

export async function fetchInstalmentsPlan(
  incomingPayment: IncomingPayment,
  userInputValues: UserInputValues,
): Promise<{ [string]: Receipt }> {
  const receipts = getReceipts(incomingPayment);
  const amountLocal = getAmountLocal(receipts);
  const currencyCode = getCurrencyCode(amountLocal);
  const apiInstalments = await getInstalmentsPlanFromApi(incomingPayment, userInputValues);

  return normalizeInstalmentsPlan(apiInstalments, currencyCode);
}
